/*
 * Gift unlock quick-add row — 1-tap bridge products in the cart drawer.
 *
 * Loaded unconditionally from sections/cart-drawer.liquid. It MUST live in an asset
 * rather than inline in snippets/gift-unlock-row.liquid: the snippet only renders once
 * the cart is non-empty, and markup injected by the drawer's section morph never
 * executes its inline <script>, so the buttons would render with no handler attached.
 */
(function () {
  if (window.__giftUnlockRowBound) return;
  window.__giftUnlockRowBound = true;

  var SELECTOR = '.gift-unlock__add';
  var WIDGETS = ['.gift-ladder-bar', '#GiftUnlockRow'];
  var busy = false;

  function route(name, fallback) {
    var routes = (window.theme && window.theme.routes) || {};
    return routes[name] || fallback;
  }

  function bundledSections() {
    var sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sections } })
    );
    return sections;
  }

  // The drawer morph does not always cover the footer widgets, so swap them from the
  // section HTML the cart returned.
  function refreshWidgets(btn, sections) {
    var host = btn.closest('.shopify-section');
    var id = host && host.id ? host.id.replace('shopify-section-', '') : null;
    var html = id && sections ? sections[id] : null;
    if (!html) return false;

    var doc = new DOMParser().parseFromString(html, 'text/html');
    WIDGETS.forEach(function (sel) {
      var current = document.querySelector(sel);
      if (!current) return;
      var fresh = doc.querySelector(sel);
      if (fresh) current.replaceWith(fresh);
      else current.remove();
    });
    return true;
  }

  document.addEventListener('click', async function (event) {
    var btn = event.target.closest(SELECTOR);
    if (!btn || btn.disabled || busy) return;

    event.preventDefault();
    busy = true;
    btn.disabled = true;

    try {
      var added = await fetch(route('cart_add_url', '/cart/add.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] })
      });
      if (!added.ok) throw new Error('cart/add failed: ' + added.status);

      var sections = bundledSections();
      if (!sections.length) {
        window.location.reload();
        return;
      }

      var updated = await fetch(route('cart_update_url', '/cart/update.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ sections: sections.join(',') })
      });
      var cart = await updated.json();
      if (!cart || !cart.sections) {
        window.location.reload();
        return;
      }

      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      refreshWidgets(btn, cart.sections);
    } catch (err) {
      window.location.reload();
    } finally {
      // Always release: on the happy path the row is replaced with fresh enabled
      // buttons, but when it is not, this is what keeps the button clickable.
      busy = false;
      btn.disabled = false;
    }
  });
})();
